module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"learningPortal":"Unterweisungsportal"},"en":{"learningPortal":"Learning portal"}}')
  delete Component.options._Ctor
}
